import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import AppPage from '../components/page';
import PageErrorBoundary from '../components/page-error';
import Settings from '../context/settings';
import ContactDetails from '../pages/contact-details';
import End from '../pages/end';
import MicCheck from '../pages/mic-check';
import Playback from '../pages/playback';
import Recording from '../pages/recording';
import Start from '../pages/start';
import Privacy from '../pages/privacy';
import SendVox from '../pages/send-vox';
import HostedTags from '../pages/tags/hosted-tags';


const BannerImage = styled.img`
  width: 100%
  height: inherit;
  max-height: inherit;
  display: ${(props) => !props.headerLogoRequired && 'none'};

  border-radius: 7px 7px 0px 0px;
  display: ${(props) => !props.headerLogoRequired && 'none'}
  @media (max-width: 599px) {
      border-radius: 0;
  }
`;
const Bannerdiv = styled.div`
  height: 111px;
  border-radius: 7px 7px 0px 0px;
  @media (max-width: 599px) {
      border-radius: 0;
  }
`;
const AppPages = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    height: 96%;
    width: 100%;

    flex: 9;

    .hide {
        display: none;
    }
`;

export default class Pages extends Component {
  constructor(props) {
    super(props);
    this.handleAudioContext = props.handleAudioContext;
  }
    static propTypes = {
      active: PropTypes.string.isRequired,
      onSwitch: PropTypes.func.isRequired
    }

    state = {
      pages: {
          'start': Start,
          'recording': Recording,
          'contact': ContactDetails,
          'mic-check': MicCheck,
          'playback': Playback,
          'complete': End,
          'privacy' : Privacy,
          'send-vox' : SendVox,
          'tags' : HostedTags,
      },
      audioContext: null,
    }

    componentDidMount() {
    }

    render() {
      const { active, audioContext, handleAudioContext, ...pageProps } = this.props;
      const { pages } = this.state;
      const { pluginMode } = pageProps;
      const MODE = ((process.env.REACT_APP_BUILD_MODE === 'hosted'));

      return (
        <AppPages pluginMode={pluginMode}>
          <PageErrorBoundary>
            {Object.entries(pages).map(([key, Page], index) => (key !== active ? null : (
              <Settings.Consumer key={key}>
                {(settings) => (
                  <AppPage
                    mode={MODE.toString()}
                    pluginMode={pluginMode.toString()}
                    settings={settings}
                    name={"sdfsdfsdf"}
                    key={`app-page-${index}`}
                    className={`page-${key} ${active === key ? 'active' : 'hide'}`}
                  >
                    {MODE ? (
                      <div
                        className="banner">
                          <Bannerdiv style={{
                              fontFamily: settings.common.fontFamily,
                              backgroundImage: `linear-gradient(to right, ${settings.common.headerGradientLeftColor},
                              ${settings.common.headerGradientRightColor})`,
                          }}
                          >
                          <BannerImage headerLogoRequired={settings.common.headerLogoRequired} src={settings.common.headerLogoRequired && settings.common.logoUrl ? settings.common.logoUrl :
                              settings.common.isPublicHosted ? ('/img/Banner.svg') : settings.common.headerLogoRequired && ('/img/ta-logo-plain-bg.png')} />
                        </Bannerdiv>
                      </div>
                    ) : null}
                    <Page
                      {...pageProps}
                      settings={settings}
                      isPublicHosted={settings.common.isPublicHosted}
                      audioContext={audioContext}
                      handleAudioContext={(audioCon) => handleAudioContext(audioCon)}
                    />
                  </AppPage>
                )}
              </Settings.Consumer>
            )))}
          </PageErrorBoundary>
        </AppPages>
      );
    }
}
